import React, { Component } from 'react';
import { Row, Col, Button, Card, CardHeader, CardBody, Spinner } from "reactstrap";
import showToast from "../../components/showToast";
import call_api from "../../components/api-caller";
import { AvForm, AvField } from 'availity-reactstrap-validation';
import moment from 'moment-timezone';

const DAY_LABELS = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

const COMMON_TIMEZONES = [
	"Asia/Kolkata",
	"America/New_York",
	"America/Chicago",
	"America/Denver",
	"America/Los_Angeles",
	"Europe/London",
	"Europe/Berlin",
	"Europe/Paris",
	"Asia/Dubai",
	"Asia/Singapore",
	"Asia/Tokyo",
	"Australia/Sydney",
	"Pacific/Auckland",
	"UTC",
];

class CompanyPage extends Component {
	constructor(props) {
		super(props);
		this.state = {
			compDetails: {},
			compConfig: {},
			workHoursPolicy: {
				enabled: false,
				workDays: [0, 1, 2, 3, 4],
				workStartHour: 9,
				workStartMinute: 0,
				workEndHour: 18,
				workEndMinute: 0,
				timezone: "Asia/Kolkata",
			},
			savingPolicy: false,
		}
		this.modify_company_details = this.modify_company_details.bind(this);
		this.save_work_hours_policy = this.save_work_hours_policy.bind(this);
	}

	async get_company_details() {
		var query =`query {
			getMyCompanyDetails(email: "${this.props.email}", token: "${this.props.token}", realm: "${this.props.realm}", domain: "${this.props.domain}"){
				companyName
				gstin
				address
			}
		}`;
		const data = await call_api(query);
		if ( data && data.data && data.data.getMyCompanyDetails){
			this.setState({
				compDetails: data.data.getMyCompanyDetails
			});
		}
	}

	async get_company_config() {
		var query =`query {
			getCompanyConfig(email: "${this.props.email}", token: "${this.props.token}", realm: "${this.props.realm}", domain: "${this.props.domain}"){
				rdpDomainLogin
				hiddenCustomer
				disableVmControls
				workHoursPolicy {
					enabled
					workDays
					workStartHour
					workStartMinute
					workEndHour
					workEndMinute
					timezone
				}
			}
		}`;
		const data = await call_api(query);
		if ( data && data.data && data.data.getCompanyConfig){
			this.setState({
				compConfig: data.data.getCompanyConfig
			});
			if (data.data.getCompanyConfig.workHoursPolicy) {
				this.setState({
					workHoursPolicy: data.data.getCompanyConfig.workHoursPolicy
				});
			}
		}
	}

	async modify_company_config() {
		const query = `mutation {
			changeCompanyConfig(email: "${this.props.email}", token: "${this.props.token}", realm: "${this.props.realm}", domain: "${this.props.domain}", rdpDomLogin: ${this.state.compConfig.rdpDomainLogin ? "true": "false"}) {
				result
			}
		}`;
		const data = await call_api(query);
		if ( data && data.data && data.data.changeCompanyConfig){
			if (data.data.changeCompanyConfig.result) {
				showToast("Configuration modified successfully", "The company configuration has been modified successfully", "success");
				this.get_company_config();
			} else {
				showToast("Configuration modification failed", "There is an error modifying company configuration. Please try again after some time.", "error");
			}
		} else {
			showToast("Configuration modification failed", "You may not have enough privileges to modify company configuration.", "error");
		}
	}

	async save_work_hours_policy() {
		const { workHoursPolicy } = this.state;
		this.setState({ savingPolicy: true });
		const query = `mutation {
			updateOrgWorkHoursPolicy(
				email: "${this.props.email}",
				token: "${this.props.token}",
				realm: "${this.props.realm}",
				domain: "${this.props.domain}",
				policy: {
					enabled: ${workHoursPolicy.enabled},
					workDays: [${workHoursPolicy.workDays.join(", ")}],
					workStartHour: ${workHoursPolicy.workStartHour},
					workStartMinute: ${workHoursPolicy.workStartMinute},
					workEndHour: ${workHoursPolicy.workEndHour},
					workEndMinute: ${workHoursPolicy.workEndMinute},
					timezone: "${workHoursPolicy.timezone}"
				}
			) {
				result
			}
		}`;
		const data = await call_api(query);
		this.setState({ savingPolicy: false });
		if (data && data.data && data.data.updateOrgWorkHoursPolicy) {
			if (data.data.updateOrgWorkHoursPolicy.result) {
				showToast("Work hours policy updated", "The work hours policy has been updated successfully", "success");
				this.get_company_config();
			} else {
				showToast("Update failed", "There is an error updating the work hours policy. Please try again after some time.", "error");
			}
		} else {
			showToast("Update failed", "You may not have enough privileges to modify the work hours policy.", "error");
		}
	}

	toggleWorkDay(dayIndex) {
		const { workHoursPolicy } = this.state;
		const workDays = [...workHoursPolicy.workDays];
		const idx = workDays.indexOf(dayIndex);
		if (idx >= 0) {
			workDays.splice(idx, 1);
		} else {
			workDays.push(dayIndex);
			workDays.sort();
		}
		this.setState({
			workHoursPolicy: { ...workHoursPolicy, workDays }
		});
	}

	async modify_company_details(event, values) {
		const query = `mutation {
			modifyCompanyDetails(email: "${this.props.email}", token: "${this.props.token}", realm: "${this.props.realm}", domain: "${this.props.domain}", companyName: ${JSON.stringify(values.comp_name)}, address: ${JSON.stringify(values.address)}, gstin: "${values.gstin}") {
				result
			}
		}`;
		const data = await call_api(query);
		if ( data && data.data && data.data.modifyCompanyDetails){
			if (data.data.modifyCompanyDetails.result) {
				showToast("Details modified successfully", "The company details have been modified successfully", "success");
				this.get_company_details();
			} else {
				showToast("Details modification failed", "There is an error modifying company details. Please try again after some time.", "error");
			}
		} else {
			showToast("Details modification failed", "You may not have enough privileges to modify company Details.", "error");
		}
	}

	componentDidMount() {
		this.get_company_details();
		this.get_company_config();
	}

	formatTime(hour, minute) {
		return `${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}`;
	}

	renderHourOptions() {
		const options = [];
		for (let i = 0; i < 24; i++) {
			options.push(<option key={i} value={i}>{String(i).padStart(2, '0')}</option>);
		}
		return options;
	}

	renderMinuteOptions() {
		const options = [];
		for (let i = 0; i < 60; i += 15) {
			options.push(<option key={i} value={i}>{String(i).padStart(2, '0')}</option>);
		}
		return options;
	}

	render() {
		const { workHoursPolicy, savingPolicy } = this.state;
		return (<React.Fragment>
			<Card>
				<CardHeader>Company Details</CardHeader>
				<CardBody>
					<Row>
						<Col lg="8">
							<AvForm onValidSubmit={this.modify_company_details}>
								<AvField
									type="text"
									name="comp_name"
									label="Company Name"
									placeholder="Name of your Company"
									required
									value={this.state.compDetails.companyName}
								/>
								<AvField
									type="text"
									name="address"
									label="Company Address"
									placeholder="Address of your Company"
									required
									value={this.state.compDetails.address}
								/>
								<AvField
									type="text"
									name="gstin"
									label="GSTIN Regn Number"
									placeholder="GSTIN of your Company"
									required
									validate={{
										pattern: {
											value: "^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$",
											errorMessage: "Invalid GSTIN number"
										}
									}}
									value={this.state.compDetails.gstin}
								/>
								<Button className="btn btn-success btn-block">
									Submit
								</Button>
							</AvForm>
						</Col>
					</Row>
				</CardBody>
			</Card>
			<Card>
				<CardHeader>Company Configuration</CardHeader>
				<CardBody>
					<Row>
						<Col md={8} lg={8}>
							<div className="custom-control custom-checkbox mb-3">
								<input
									type="checkbox"
									className="custom-control-input"
									id="CustomCheck1"
									onChange={() => false}
									checked={this.state.compConfig.rdpDomainLogin}
								/>
								<label
								className="custom-control-label"
								onClick={() => {
									var compConfig = this.state.compConfig;
									compConfig.rdpDomainLogin = !compConfig.rdpDomainLogin;
									this.setState({
										compConfig: compConfig,
									})
								}}
								>
								RDP Domain Login
								</label>
							</div>
						</Col>
					</Row>
					<Row>
						<Col md={8} lg={8}>
							<Button className="btn btn-info btn-block" onClick={() => this.modify_company_config()}>
								Modify
							</Button>
						</Col>
					</Row>
				</CardBody>
			</Card>
			<Card>
				<CardHeader>
					Work Hours Policy
					<span className="float-right">
						<div className="custom-control custom-switch">
							<input
								type="checkbox"
								className="custom-control-input"
								id="workHoursEnabled"
								checked={workHoursPolicy.enabled}
								onChange={() => {
									this.setState({
										workHoursPolicy: { ...workHoursPolicy, enabled: !workHoursPolicy.enabled }
									});
								}}
							/>
							<label className="custom-control-label" htmlFor="workHoursEnabled">
								{workHoursPolicy.enabled ? "Enabled" : "Disabled"}
							</label>
						</div>
					</span>
				</CardHeader>
				<CardBody>
					<Row>
						<Col md={8} lg={8}>
							<div className="mb-3">
								<label className="font-weight-bold d-block mb-2">Work Days</label>
								<div className="btn-group" role="group">
									{DAY_LABELS.map((label, idx) => (
										<button
											key={idx}
											type="button"
											className={`btn btn-sm ${workHoursPolicy.workDays.includes(idx) ? "btn-primary" : "btn-outline-secondary"}`}
											onClick={() => this.toggleWorkDay(idx)}
										>
											{label}
										</button>
									))}
								</div>
							</div>
							<Row className="mb-3">
								<Col md={6}>
									<label className="font-weight-bold">Start Time</label>
									<div className="d-flex align-items-center">
										<select
											className="form-control mr-1"
											style={{ width: 80 }}
											value={workHoursPolicy.workStartHour}
											onChange={(e) => this.setState({
												workHoursPolicy: { ...workHoursPolicy, workStartHour: parseInt(e.target.value) }
											})}
										>
											{this.renderHourOptions()}
										</select>
										<span className="mx-1">:</span>
										<select
											className="form-control ml-1"
											style={{ width: 80 }}
											value={workHoursPolicy.workStartMinute}
											onChange={(e) => this.setState({
												workHoursPolicy: { ...workHoursPolicy, workStartMinute: parseInt(e.target.value) }
											})}
										>
											{this.renderMinuteOptions()}
										</select>
									</div>
								</Col>
								<Col md={6}>
									<label className="font-weight-bold">End Time</label>
									<div className="d-flex align-items-center">
										<select
											className="form-control mr-1"
											style={{ width: 80 }}
											value={workHoursPolicy.workEndHour}
											onChange={(e) => this.setState({
												workHoursPolicy: { ...workHoursPolicy, workEndHour: parseInt(e.target.value) }
											})}
										>
											{this.renderHourOptions()}
										</select>
										<span className="mx-1">:</span>
										<select
											className="form-control ml-1"
											style={{ width: 80 }}
											value={workHoursPolicy.workEndMinute}
											onChange={(e) => this.setState({
												workHoursPolicy: { ...workHoursPolicy, workEndMinute: parseInt(e.target.value) }
											})}
										>
											{this.renderMinuteOptions()}
										</select>
									</div>
								</Col>
							</Row>
							<div className="mb-3">
								<label className="font-weight-bold">Timezone</label>
								<select
									className="form-control"
									value={workHoursPolicy.timezone}
									onChange={(e) => this.setState({
										workHoursPolicy: { ...workHoursPolicy, timezone: e.target.value }
									})}
								>
									{COMMON_TIMEZONES.map((tz) => (
										<option key={tz} value={tz}>{tz} (UTC{moment.tz(tz).format('Z')})</option>
									))}
								</select>
							</div>
							<div className="mb-3 p-3 bg-light rounded">
								<small className="text-muted">
									Current policy: {workHoursPolicy.workDays.map(d => DAY_LABELS[d]).join(", ")} | {this.formatTime(workHoursPolicy.workStartHour, workHoursPolicy.workStartMinute)} - {this.formatTime(workHoursPolicy.workEndHour, workHoursPolicy.workEndMinute)} ({workHoursPolicy.timezone})
								</small>
							</div>
							<Button
								className="btn btn-success btn-block"
								onClick={this.save_work_hours_policy}
								disabled={savingPolicy}
							>
								{savingPolicy ? <Spinner size="sm" /> : "Save Work Hours Policy"}
							</Button>
						</Col>
					</Row>
				</CardBody>
			</Card>
		</React.Fragment>)
	}
}

export default CompanyPage;